import { render, staticRenderFns } from "./userlistPakgConfig.vue?vue&type=template&id=3c37ea2e&"
import script from "./userlistPakgConfig.vue?vue&type=script&lang=js&"
export * from "./userlistPakgConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c37ea2e')) {
      api.createRecord('3c37ea2e', component.options)
    } else {
      api.reload('3c37ea2e', component.options)
    }
    module.hot.accept("./userlistPakgConfig.vue?vue&type=template&id=3c37ea2e&", function () {
      api.rerender('3c37ea2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pakgConfig/userlistPakgConfig.vue"
export default component.exports